<template>
  <div v-if="dialog.visible" class="dialog_box">
    <el-dialog
      class="reset_el-dialog"
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :before-close="doDialogClose"
      :close-on-click-modal="false"
      append-to-body
      width="600px"
    >
      <div class="search-list">
        <div class="filter">
          <div class="filter-top">
            <template v-if="dialog.showLink">
              <el-button type="primary" class="lBtn" @click="toLink(1)">国内发货流程</el-button>
              <el-button type="primary" class="lBtn" @click="toLink(2)">海外发货流程</el-button>
            </template>
            <template v-else>
              <div class="input el-input-dark">
                <div class="text">订单号</div>
                <el-input placeholder="请输入" v-model='dialog.kw'/>
              </div>
              <el-button type="primary" @click="doDialogSave">搜索</el-button>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import common from '@/utils/common'
export default {
  data () {
    return {
      dialog: this.clearDialog()
    }
  },

  // 实例创建后,进行默认数据处理
  created () {},

  methods: {
    // 弹框参数
    clearDialog () {
      const obj = {
        visible: false,
        title: '',
        kw: '171-4039624-7843510',
        showLink: true, // 是否显示跳转入口
        type: null
      }
      return obj
    },
    // 初始方法
    init (list = []) {
      this.dialog.visible = true
    },
    // 跳转入口 type 1 国内发货流程 2 海外发货流程
    toLink (type) {
      this.dialog.type = type
      this.dialog.showLink = false
    },
    // 搜索
    doDialogSave () {
      const type = this.dialog.type
      const getKw = this.dialog.kw
      let setLink = `${location.origin}/static/order`
      if (type === 1) {
        setLink = `${setLink}/domestic/index.html?no=${getKw}`
      } if (type === 2) {
        setLink = `${setLink}/overseas/index.html?no=${getKw}`
      }
      common.newWindowOpen(setLink)
      this.doDialogClose()
    },

    // 点击关闭
    doDialogClose () {
      this.dialog = this.clearDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
  .filter-top{
    padding:10px 32px;
    display: flex;
    align-items: center;
    margin-bottom:16px;
    border-radius: 4px;
    .input{
      display: flex;
      width: calc(100% - 120px);
      align-items: center;
      margin-right: 10px;
      .text{
        width: 100px;
        font-size:16px;
      }
    }
    .lBtn {
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/order/searchDialog/index.vue